import { simpleSet } from '@r/reducers/utils';

const setCalculationModeProjectName = simpleSet as
  redux.reducers.calculationMode.settings.information.projectName;

export const projectName = setCalculationModeProjectName(
  'SET_CALCULATION_MODE_PROJECT_NAME',
  'Test Project'
);
